import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "mb-0 ml-3" }
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = { class: "px-3" }
const _hoisted_8 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "mt-4" }
const _hoisted_11 = { class: "px-3" }
const _hoisted_12 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "mt-4" }
const _hoisted_15 = { class: "px-3" }
const _hoisted_16 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "mt-4" }
const _hoisted_19 = { class: "px-3" }
const _hoisted_20 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "mb-2" }
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { class: "mb-0 ml-3" }
const _hoisted_25 = { class: "mt-4" }
const _hoisted_26 = { class: "px-3" }
const _hoisted_27 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "mt-4" }
const _hoisted_30 = { class: "px-3" }
const _hoisted_31 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "mt-4" }
const _hoisted_34 = { class: "px-3" }
const _hoisted_35 = { class: "d-flex justify-content-end mt-3 px-2" }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { class: "mt-4" }
const _hoisted_38 = { class: "px-3" }
const _hoisted_39 = { class: "d-flex justify-content-end mt-3 px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Slider = _resolveComponent("Slider")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.preferenceLabel)
      ? (_openBlock(), _createBlock("h1", _hoisted_1, _toDisplayString(_ctx.preferenceLabel), 1))
      : _createCommentVNode("", true),
    (_ctx.roomObject.thermoTypeOfObject !== _ctx.ThermoTypeOfObject.Cooling)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("h5", _hoisted_3, _toDisplayString(_ctx.$t("AppResource.HeatingUpper")), 1),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.roomObject.isManualHeatingOverrideEnabled,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.roomObject.isManualHeatingOverrideEnabled = $event)),
              disabled: _ctx.readOnly
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.EnableManualOverride")), 1)
          ]),
          _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("AppResource.HeatingRegulationBand")), 1),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_Slider, {
              disabled: 
                        !_ctx.roomObject.isManualHeatingOverrideEnabled || _ctx.readOnly
                    ,
              modelValue: _ctx.heatingRegulationBand,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.heatingRegulationBand = $event)),
              min: 1,
              max: 100,
              step: 1
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("span", null, _toDisplayString(_ctx.roomObject.heatingRegulationBand), 1)
          ]),
          (_ctx.roomObject.hasHeatingFancoils)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("AppResource.FanSpeed2ForHeating")), 1),
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_Slider, {
                    disabled: 
                            !_ctx.roomObject.IsManualHeatingOverrideEnabled ||
                            _ctx.readOnly
                        ,
                    modelValue: _ctx.fanSpeed2ForHeating,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.fanSpeed2ForHeating = $event)),
                    min: 2,
                    max: 200,
                    step: 1
                  }, null, 8, ["disabled", "modelValue"])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("span", null, _toDisplayString(_ctx.roomObject.fanSpeed2ForHeating), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.roomObject.hasHeatingFancoils)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("AppResource.FanSpeed3ForHeating")), 1),
                _createVNode("div", _hoisted_15, [
                  _createVNode(_component_Slider, {
                    disabled: 
                            !_ctx.roomObject.IsManualHeatingOverrideEnabled ||
                            _ctx.readOnly
                        ,
                    modelValue: _ctx.fanSpeed3ForHeating,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.fanSpeed3ForHeating = $event)),
                    min: 3,
                    max: 300,
                    step: 1
                  }, null, 8, ["disabled", "modelValue"])
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode("span", null, _toDisplayString(_ctx.roomObject.fanSpeed3ForHeating), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.roomObject.hasHeatingFancoils)
            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                _createVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("AppResource.ValvesTimeForHeatingFanCoil")), 1),
                _createVNode("div", _hoisted_19, [
                  _createVNode(_component_Slider, {
                    disabled: 
                            !_ctx.roomObject.IsManualHeatingOverrideEnabled ||
                            _ctx.readOnly
                        ,
                    modelValue: _ctx.valvesTimeForHeatingFanCoil,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.valvesTimeForHeatingFanCoil = $event)),
                    min: 0,
                    max: 1275,
                    step: 5
                  }, null, 8, ["disabled", "modelValue"])
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("span", null, _toDisplayString(_ctx.roomObject.valvesTimeForHeatingFanCoil), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.roomObject.thermoTypeOfObject !== _ctx.ThermoTypeOfObject.Heating)
      ? (_openBlock(), _createBlock("div", _hoisted_21, [
          _createVNode("h5", _hoisted_22, _toDisplayString(_ctx.$t("AppResource.CoolingUpper")), 1),
          _createVNode("div", _hoisted_23, [
            _createVNode(_component_InputSwitch, {
              modelValue: _ctx.roomObject.isManualCoolingOverrideEnabled,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.roomObject.isManualCoolingOverrideEnabled = $event)),
              disabled: _ctx.readOnly
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("AppResource.EnableManualOverride")), 1)
          ]),
          _createVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("AppResource.CoolingRegulationBand")), 1),
          _createVNode("div", _hoisted_26, [
            _createVNode(_component_Slider, {
              disabled: 
                        !_ctx.roomObject.isManualCoolingOverrideEnabled || _ctx.readOnly
                    ,
              modelValue: _ctx.coolingRegulationBand,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.coolingRegulationBand = $event)),
              min: 1,
              max: 100,
              step: 1
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _createVNode("div", _hoisted_27, [
            _createVNode("span", null, _toDisplayString(_ctx.roomObject.coolingRegulationBand), 1)
          ]),
          (_ctx.roomObject.hasCoolingFancoils)
            ? (_openBlock(), _createBlock("div", _hoisted_28, [
                _createVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("AppResource.FanSpeed2ForCooling")), 1),
                _createVNode("div", _hoisted_30, [
                  _createVNode(_component_Slider, {
                    disabled: 
                            !_ctx.roomObject.isManualCoolingOverrideEnabled ||
                            _ctx.readOnly
                        ,
                    modelValue: _ctx.fanSpeed2ForCooling,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.fanSpeed2ForCooling = $event)),
                    min: 2,
                    max: 200,
                    step: 1
                  }, null, 8, ["disabled", "modelValue"])
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode("span", null, _toDisplayString(_ctx.roomObject.fanSpeed2ForCooling), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.roomObject.hasCoolingFancoils)
            ? (_openBlock(), _createBlock("div", _hoisted_32, [
                _createVNode("p", _hoisted_33, _toDisplayString(_ctx.$t("AppResource.FanSpeed3ForCooling")), 1),
                _createVNode("div", _hoisted_34, [
                  _createVNode(_component_Slider, {
                    disabled: 
                            !_ctx.roomObject.isManualCoolingOverrideEnabled ||
                            _ctx.readOnly
                        ,
                    modelValue: _ctx.fanSpeed3ForCooling,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.fanSpeed3ForCooling = $event)),
                    min: 3,
                    max: 300,
                    step: 1
                  }, null, 8, ["disabled", "modelValue"])
                ]),
                _createVNode("div", _hoisted_35, [
                  _createVNode("span", null, _toDisplayString(_ctx.roomObject.fanSpeed3ForCooling), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.roomObject.hasCoolingFancoils)
            ? (_openBlock(), _createBlock("div", _hoisted_36, [
                _createVNode("p", _hoisted_37, _toDisplayString(_ctx.$t("AppResource.ValvesTimeForCoolingFanCoil")), 1),
                _createVNode("div", _hoisted_38, [
                  _createVNode(_component_Slider, {
                    disabled: 
                            !_ctx.roomObject.isManualCoolingOverrideEnabled ||
                            _ctx.readOnly
                        ,
                    modelValue: _ctx.roomObject.valvesTimeForCoolingFanCoil,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.roomObject.valvesTimeForCoolingFanCoil = $event)),
                    min: 0,
                    max: 1275,
                    step: 5
                  }, null, 8, ["disabled", "modelValue"])
                ]),
                _createVNode("div", _hoisted_39, [
                  _createVNode("span", null, _toDisplayString(_ctx.roomObject.valvesTimeForCoolingFanCoil), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}